import AppSidebar from '@/common/components/AppSidebar'
import { navItems } from '@/modules/operator/constants'
import { Outlet } from 'react-router-dom'
import usePollingPendingWithdrawals from '@/common/hooks/usePollingPendingWithdrawals'
import { ChatSseProvider } from '@/modules/chat/sse'
import { SidebarBadgesProvider } from '@/common/hooks/useSidebarBadges'
import { LowQuotaWarningDialog } from '@/modules/quota/components/LowQuotaWarningDialog'
import { LineQuotaWarningDialog } from '@/modules/quota/components/LineQuotaWarningDialog'

export default function AgentLayout() {
	usePollingPendingWithdrawals()

	return (
		<ChatSseProvider>
			<SidebarBadgesProvider>
				<AppSidebar prefixPath="operator" navItems={navItems}>
					<Outlet />
				</AppSidebar>
				<LowQuotaWarningDialog />
				<LineQuotaWarningDialog />
			</SidebarBadgesProvider>
		</ChatSseProvider>
	)
}
